import { render } from "./AuthPage.vue?vue&type=template&id=7dd7f6da&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=7dd7f6da&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd7f6da"]])

export default __exports__